import { BaseFieldAPI } from '../field/base-field-api.js';
class LocatorFieldAPI extends BaseFieldAPI {
    getValue() {
        const data = this.getData();
        const entry = this.getEntry();
        return data[entry];
    }
    setValue(value) {
        const { entry, data } = this.state;
        const oldValue = data[entry];
        data[entry] = value;
        this.setState({ data });
        this.onChange.fire({ entry, oldValue, value });
    }
}
export default LocatorFieldAPI;
//# sourceMappingURL=locator-field-api.js.map